import { ReactComponent as SplashIcon } from '../../assets/img/splash/splash.svg'

export default function SplashScreen() {
    return (
        <div
            className="splashScreen"
        >
            <div className="wrapper">
                <SplashIcon />
            </div>
        </div>
    )
}
